// extracted by mini-css-extract-plugin
export default {"restart":"Facts_restart__fGM-G"};